import { TAG_CODES } from "../../tag.config"

const GOM_ACTION_SIMULTANEOUS = {
    type: 'path',
    tagCode: TAG_CODES.ACTION,
    withText: true,
    defaultText: 'Simultaneous action',
    positionText: 'top', // top - right - center - bottom - left
    fieldsText: ["title"],
    endTextWidthStr: "",
    angle: 0,
    colorCodeId: 'fire',
    withFillColor: true,
    schema: {
        "type": 'object',
        "properties": {
            "title": {
                "title": "Text",
                "description": "Write a text",
                "type": "string",
            },
        },
        "required": []
    },
    pathData: `M 10 70 H 150 M 50 70 L 70 45 L 78 52 L 79 33 L 61 39 L 70 45 M 80 70 L 100 45 L 108 52 L 109 33 L 91 39 L 100 45 M 110 70 L 130 45 L 138 52 L 139 33 L 121 39 L 130 45`,
}

export default GOM_ACTION_SIMULTANEOUS